export default __webpack_public_path__ + "static/media/avatar-group-hover.754651d2.svg";